import React from 'react';
import { useQuery } from '@apollo/client';
import { grey } from '@mui/material/colors';
import { RemoveCircle } from '@mui/icons-material';
import { IconButton, Skeleton, Stack } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { EquipmentCardContent } from 'components/shared/EquipmentCardContent';

import { GetByIdResponse, internalInventoryApi } from '../../api';

interface Props {
  id: string;
  onRemove: () => void;
  onViewUnit: (id: string) => void;
}

export const InventoryCard = ({ id, onRemove, onViewUnit }: Props) => {
  const { data, loading, error } = useQuery<GetByIdResponse>(internalInventoryApi.getById, {
    variables: { input: { id } },
  });

  const inventory = data?.result?.entity ?? null;

  if (!inventory) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      sx={{
        gap: '1rem',
        minHeight: '7rem',
        borderRadius: '0.5rem',
        padding: '0.5rem 1rem',
        alignItems: 'flex-start',
        border: `1px solid ${grey[300]}`,
      }}
    >
      <RenderWithFallback
        error={error}
        isLoading={loading}
        fallBack={<Skeleton sx={{ height: '10rem', width: '100%' }} variant="rectangular" />}
      >
        <>
          <IconButton className="icon-btn-bordered" size="small" color="error" onClick={onRemove}>
            <RemoveCircle fontSize="small" />
          </IconButton>

          <EquipmentCardContent equipment={inventory.equipment} onViewUnit={onViewUnit} />
        </>
      </RenderWithFallback>
    </Stack>
  );
};
